import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { type MetaFunction } from 'react-router'

export const handle: SEOHandle = {
	getSitemapEntries: () => [{ route: '/legal-notice/refund', priority: 0.7 }],
}

export const meta: MetaFunction = ({ location }) => {
	const title = `Refund Policy | Legal Notice | ${import.meta.env.VITE_APP_TITLE}`
	const description = `Refund Policy for ${import.meta.env.VITE_APP_TITLE} users`

	const url = `https://www.trailviewr.com${location.pathname}`

	return [
		{ title },
		{ name: 'description', content: description },
		{ tagName: 'link', rel: 'canonical', href: url },

		{ property: 'og:title', content: title },
		{ property: 'og:description', content: description },
		{ property: 'og:url', content: url },

		{ name: 'twitter:title', content: title },
		{ name: 'twitter:description', content: description },
		{ name: 'twitter:url', content: url },

		{
			'script:ld+json': {
				'@context': 'https://schema.org',
				'@type': 'WebPage',
				name: title,
				description,
				url,
			},
		},
	]
}

export default function RefundPolicyRoute() {
	return (
		<main className="mx-auto max-w-4xl px-4 py-8">
			<h1 className="mb-6 text-3xl font-bold">REFUND POLICY</h1>
			<p className="mb-4">
				<strong className="mr-2">Last updated</strong>
				<strong>October 6, 2025</strong>
			</p>
			<section className="mb-6">
				<h2 className="mb-2 text-xl font-semibold">REFUNDS</h2>
				<p className="text-gray-700">
					All sales are final and no refund will be issued.
				</p>
			</section>
			<section>
				<h2 className="mb-2 text-xl font-semibold">QUESTIONS</h2>
				<p className="mb-2 text-gray-700">
					If you have any questions concerning our return policy, please contact
					us at:
				</p>
				<p className="text-blue-600 hover:underline">
					<a href="mailto:support@trailviewr.com">support@trailviewr.com</a>
				</p>
			</section>
		</main>
	)
}
